import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-[#e2dcd4] bg-[#f4f0ea]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-4">
            <img src="/logo-badge.png" alt="Happiness is no tan lines" className="w-16 h-16" data-testid="footer-logo" />
            <p className="font-display text-3xl text-[#1f402b]">kiwibares<span className="text-[#c5903b]">.nz</span></p>
          </div>
          <p className="mt-4 text-sm text-[#5a665e] max-w-sm leading-relaxed">
            Honest, open naturism from Aotearoa — places, people and practical guidance. Non-sexual, consent-based and for adults 18+.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="eyebrow mb-4">Explore</p>
          <ul className="space-y-2 text-sm">
            <li><Link className="link-u text-[#1a261f]" to="/galleries" data-testid="footer-galleries-link">Galleries</Link></li>
            <li><Link className="link-u text-[#1a261f]" to="/articles" data-testid="footer-articles-link">Articles</Link></li>
            <li><Link className="link-u text-[#1a261f]" to="/locations" data-testid="footer-locations-link">Locations</Link></li>
            <li><Link className="link-u text-[#1a261f]" to="/events" data-testid="footer-events-link">Events</Link></li>
            <li><Link className="link-u text-[#1a261f]" to="/about" data-testid="footer-about-link">About</Link></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="eyebrow mb-4">Trust</p>
          <ul className="space-y-2 text-sm">
            <li><Link className="link-u text-[#1a261f]" to="/contact" data-testid="footer-contact-link">Contact & enquiries</Link></li>
            <li><Link className="link-u text-[#1a261f]" to="/legal" data-testid="footer-legal-link">Legal & content policy</Link></li>
            <li><Link className="link-u text-[#1a261f]" to="/admin" data-testid="nav-admin-link">Admin</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#e2dcd4]">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 flex flex-col sm:flex-row justify-between gap-2 font-mono-k text-[11px] text-[#5a665e]">
          <span>© {new Date().getFullYear()} kiwibares.nz — Aotearoa New Zealand</span>
          <span>Regional notices are approximate and not legal advice.</span>
        </div>
      </div>
    </footer>
  );
}
